import { useState } from "react";
import { Link } from "react-router";
import {
  Body,
  Caption,
  Card,
  CardTitle,
  EmptyState,
  Subtitle,
  VField,
  VInput,
} from "@/components/ui";
import { useAvailableAssets } from "@/domains/assets";
import {
  AssetStatusBadge,
  AssetTypeIcon,
  assetTypeLabel,
} from "@/domains/assets";

export function AvailabilityCheck(): React.JSX.Element {
  const [startDate, setStartDate] = useState("2026-05-15");
  const [endDate, setEndDate] = useState("2026-05-29");

  const { data, isPending } = useAvailableAssets(startDate, endDate);

  const list = data ?? [];

  return (
    <Card padding="lg" className="space-y-4">
      <CardTitle>Beschikbaarheid checken</CardTitle>
      <div className="grid gap-3 md:grid-cols-2">
        <VField label="Begin" htmlFor="availStart">
          <VInput
            id="availStart"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </VField>
        <VField label="Eind" htmlFor="availEnd">
          <VInput
            id="availEnd"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </VField>
      </div>

      {isPending ? (
        <Subtitle>Berekenen…</Subtitle>
      ) : list.length === 0 ? (
        <EmptyState
          title="Geen vrije assets"
          description="Voor deze periode is geen enkele asset beschikbaar."
        />
      ) : (
        <div className="space-y-2">
          <Body weight="medium">{list.length} asset(s) beschikbaar in deze periode:</Body>
          <ul className="grid gap-2 md:grid-cols-2">
            {list.map((asset) => (
              <li key={asset.id}>
                <Link
                  to={`/assets/${asset.id}`}
                  className="flex items-center justify-between gap-2 rounded-md border border-border bg-muted/30 px-3 py-2 transition-colors hover:border-primary-300 hover:bg-muted"
                >
                  <div className="flex items-center gap-2">
                    <AssetTypeIcon
                      type={asset.type}
                      className="size-4 text-muted-foreground"
                    />
                    <div>
                      <Body weight="semibold">{asset.number}</Body>
                      <Caption as="p" tone="muted">
                        {assetTypeLabel(asset.type)}
                      </Caption>
                    </div>
                  </div>
                  <AssetStatusBadge status={asset.status} />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Card>
  );
}
